// 📄 tarifaService.ts
// Tarifa por hora que cada miembro configura para sí mismo, por proyecto.
// Vive en una subcolección aparte (projects/{id}/tarifas/{uid}) — y NO en
// el array `miembros` del proyecto — porque ese array es legible por todos
// los miembros (ver firestore.rules), y la tarifa es información sensible
// que solo su dueño debe poder ver.
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from '../firebase';

const tarifaRef = (projectId: string, uid: string) => doc(db, "projects", projectId, "tarifas", uid);

export const getTarifa = async (projectId: string, uid: string): Promise<number | null> => {
  const snap = await getDoc(tarifaRef(projectId, uid));
  if (!snap.exists()) return null;
  const valor = snap.data().tarifaHora;
  return typeof valor === 'number' ? valor : null;
};

export const setTarifa = async (projectId: string, uid: string, tarifaHora: number) => {
  if (tarifaHora < 0) throw new Error("La tarifa no puede ser negativa.");
  await setDoc(tarifaRef(projectId, uid), { userId: uid, tarifaHora }, { merge: true });
};
